import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ApiService from '../../common/services/ApiService';
import {
  SET_APPOINTMENT_REFERRAL_BEGIN,
  SET_APPOINTMENT_REFERRAL_SUCCESS,
  SET_APPOINTMENT_REFERRAL_FAILURE,
  SET_APPOINTMENT_REFERRAL_DISMISS_ERROR,
} from './constants';

export function setAppointmentReferral(referralUUID, args) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SET_APPOINTMENT_REFERRAL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.setAppointmentReferral(referralUUID, args).then(
        (res) => {
          dispatch({
            type: SET_APPOINTMENT_REFERRAL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SET_APPOINTMENT_REFERRAL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSetAppointmentReferralError() {
  return {
    type: SET_APPOINTMENT_REFERRAL_DISMISS_ERROR,
  };
}

export function useSetAppointmentReferral() {
  const dispatch = useDispatch();

  const { setAppointmentReferralPending, setAppointmentReferralError } = useSelector(
    state => ({
      setAppointmentReferralPending: state.referral.setAppointmentReferralPending,
      setAppointmentReferralError: state.referral.setAppointmentReferralError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((referralUUID, args) => {
    return dispatch(setAppointmentReferral(referralUUID, args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissSetAppointmentReferralError());
  }, [dispatch]);

  return {
    setAppointmentReferral: boundAction,
    setAppointmentReferralPending,
    setAppointmentReferralError,
    dismissSetAppointmentReferralError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SET_APPOINTMENT_REFERRAL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        setAppointmentReferralPending: true,
        setAppointmentReferralError: null,
      };

    case SET_APPOINTMENT_REFERRAL_SUCCESS:
      // The request is success
      return {
        ...state,
        setAppointmentReferralPending: false,
        setAppointmentReferralError: null,
      };

    case SET_APPOINTMENT_REFERRAL_FAILURE:
      // The request is failed
      return {
        ...state,
        setAppointmentReferralPending: false,
        setAppointmentReferralError: action.data.error,
      };

    case SET_APPOINTMENT_REFERRAL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setAppointmentReferralError: null,
      };

    default:
      return state;
  }
}
